// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1N6Lt","topBottomGutter":"Layout_topBottomGutter__1_qux"};